<template>
  <div class="modal-center" @click="close" :class="{ hidden }" v-if="render || !hidden">
    <div class="modal-center__table">
      <div class="modal-center__cell">
        <div class="modal-center__content" @click.stop>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { eventBus, EVENTS }     from "../event_bus";
  import Switcher                 from "./switcher.vue";

  export default {
    name: "ModalCenter",
    data() {
      return {
        hidden: true
      };
    },
    props: {
      render: Boolean,
      //onClose: Function,
      //onShow: Function,
    },
    methods: {
      show() {
        this.hidden = false;
        this.$emit("show");
        //this.onShow && this.onShow();
      },
      close() {
        this.hidden = true;
        this.$emit("close");
        //this.onClose && this.onClose();
      },
    }
  }
</script>
